var map = {
	"./af-ZA.json": "./src/assets/i18n/af-ZA.json",
	"./ar-MA.json": "./src/assets/i18n/ar-MA.json",
	"./bg.json": "./src/assets/i18n/bg.json",
	"./cs.json": "./src/assets/i18n/cs.json",
	"./da.json": "./src/assets/i18n/da.json",
	"./de-AT.json": "./src/assets/i18n/de-AT.json",
	"./de-BE.json": "./src/assets/i18n/de-BE.json",
	"./de-CH.json": "./src/assets/i18n/de-CH.json",
	"./de.json": "./src/assets/i18n/de.json",
	"./el.json": "./src/assets/i18n/el.json",
	"./en-GB.json": "./src/assets/i18n/en-GB.json",
	"./en-IE.json": "./src/assets/i18n/en-IE.json",
	"./en.json": "./src/assets/i18n/en.json",
	"./es-419.json": "./src/assets/i18n/es-419.json",
	"./es.json": "./src/assets/i18n/es.json",
	"./fr-BE.json": "./src/assets/i18n/fr-BE.json",
	"./fr-CH.json": "./src/assets/i18n/fr-CH.json",
	"./fr-MA.json": "./src/assets/i18n/fr-MA.json",
	"./fr.json": "./src/assets/i18n/fr.json",
	"./ga-IE.json": "./src/assets/i18n/ga-IE.json",
	"./hr-HR.json": "./src/assets/i18n/hr-HR.json",
	"./hu.json": "./src/assets/i18n/hu.json",
	"./it.json": "./src/assets/i18n/it.json",
	"./ja.json": "./src/assets/i18n/ja.json",
	"./nl.json": "./src/assets/i18n/nl.json",
	"./pl.json": "./src/assets/i18n/pl.json",
	"./pt-BR.json": "./src/assets/i18n/pt-BR.json",
	"./pt-PT.json": "./src/assets/i18n/pt-PT.json",
	"./ro.json": "./src/assets/i18n/ro.json",
	"./ru.json": "./src/assets/i18n/ru.json",
	"./sk.json": "./src/assets/i18n/sk.json",
	"./sr-RS.json": "./src/assets/i18n/sr-RS.json",
	"./sv.json": "./src/assets/i18n/sv.json",
	"./tr.json": "./src/assets/i18n/tr.json",
	"./uk.json": "./src/assets/i18n/uk.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/i18n sync recursive .json";